import React from 'react';

const FIREPlanningBottomline = () => {
  const benefits = [
    {
      title: "Financial Independence Acceleration",
      description: "Our FIRE planning strategies compress your earning timeline through strategic saving, investing, and expense optimization, potentially reducing your working years by 10-20 years compared to traditional retirement paths."
    },
    {
      title: "Lifestyle-Aligned Investment Architecture",
      description: "We design portfolios that balance aggressive growth during the accumulation phase with sustainable income generation post-independence, customized to your specific FIRE goals and risk tolerance."
    },
    {
      title: "Financial Flexibility Maximization",
      description: "Our approach creates options beyond binary work/retirement choices, enabling semi-retirement, passion pursuits, entrepreneurship, or career pivots while maintaining financial security throughout your journey."
    },
    {
      title: "Psychological Readiness Preparation",
      description: "Beyond the numbers, we help build the emotional and psychological foundation necessary for a successful transition to financial independence, addressing identity shifts and purpose development in your post-FIRE life."
    }
  ];

  return (
    <div className="w-full bg-gradient-to-br from-[#113262] to-[#1C52A0] py-16 px-8">
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        <div className="text-center mb-16">
          <h2 className="text-white text-2xl md:text-3xl lg:text-4xl font-bold mb-4">
            Bottomline: Benefits of Strategic FIRE Planning
          </h2>
          <div className="w-24 h-1 bg-[#F49611] mx-auto mt-4"></div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
          {benefits.map((benefit, index) => (
            <div key={index} className="relative">
              {/* Decorative number */}
              <div className="absolute -left-8 top-0 text-6xl font-bold text-[#F49611] opacity-10">
                {index + 1}
              </div>
              
              {/* Content */}
              <div className="relative">
                <div className="flex items-start space-x-4">
                  {/* Vertical line decoration */}
                  <div className="hidden md:block w-1 h-full bg-gradient-to-b from-[#F49611] to-transparent"></div>
                  
                  <div className="flex-1">
                    <h3 className="text-[#F49611] text-xl font-semibold mb-4">
                      {benefit.title}
                    </h3>
                    <p className="text-white/80 text-base leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FIREPlanningBottomline;